import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../hoc/Loading/Loading";
import * as actionCreators from "../../modules/actions/index";
import { connect } from "react-redux";
import axios from "../../axios";
import * as url from "../../utils/url";
import {
  Container,
  Row,
  Col,
  Table,
  Carousel,
  CarouselItem,
  CarouselIndicators,
  CarouselControl,
  Modal,
  ModalBody,
} from "reactstrap";
import moment from "moment";
import { toolkitCategories } from "../../utils/categories";
import ReactPlayer from "react-player/lazy";
import { uploadPreview } from "../../utils/constants";
import ImagePreview from "../../components/Previews/ImagePreview";

class StoriesPhotoGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      attachments: this.props.attachments.map((e) => {
        e = { ...e, isHidden: true };
        return e;
      }),
      p_att: [...this.props.attachments],
      slideIndex: 0,
    };
  }

  componentDidMount() {
    let { attachments } = this.props;
    let res = attachments.map((e, idx) => {
      if (idx != 0) {
        e = { ...e, isHidden: true };
      }
      return e;
    });
    this.setState({ attachments: res, p_att: res });
  }

  plusSlides = (n) => {
    let { slideIndex } = this.state;
    slideIndex = slideIndex + n;
    this.showSlides(slideIndex);
  };

  currentSlide = (n) => {
    this.showSlides(n);
  };

  showSlides = (n) => {
    let { dots, attachments, slideIndex, p_att } = this.state;
    var i;

    if (n >= attachments.length) {
      n = 0;
    }
    if (n < 0) {
      n = attachments.length - 1;
    }
    // for (i = 0; i < attachments.length; i++) {
    //     let result = attachments.map(e=> {
    //       e = {...e, isHidden:true}
    //       return e
    //     })
    //     this.setState({attachments:result})
    // }
    // for (i = 0; i < dots.length; i++) {
    //     dots[i].className = dots[i].className.replace(" active", "");
    // }

    let res = p_att.map((e, idx) => {
      if (idx == n) {
        e = { ...e, isHidden: false };
      } else {
        e = { ...e, isHidden: true };
      }
      return e;
    });

    this.setState({ p_att: res, slideIndex: n });
  };

  downloadFile = (itm) => {
    console.log("itm ---- ", itm);

    if (itm && itm.url) {
      try {
        fetch(itm.url+"?not-from-cache-please")
          .then((res) => res.blob()) // Gets the response and returns it as a blob
          .then((blob) => {
            // Here's where you get access to the blob
            // And you can use it for whatever you want
            // Like calling ref().put(blob)

            // Here, I use it to make an image appear on the page
            let objectURL = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = objectURL;
            link.download = `${itm.name}`;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            // let myImage = new Image();
            // myImage.src = objectURL;
            // document.getElementById('myImg').appendChild(myImage)
          })
          .catch((err) => {
            console.log("Err-inn",err);

            setTimeout(() => {
              // this.downloadFile(itm)
            }, 1000);
          });
      } catch (error) {
        console.log("Err -out",error);
      }
    }
    // console.log('itm name: ', itm.name)
    // let {name} = itm
    // const link = document.createElement('a');
    // link.href = itm.url;
    // link.download=`${name}`
    // link.target='_blank'

    // // Append to html link element page
    // document.body.appendChild(link);

    // // Start download
    // link.click();

    // // Clean up and remove the link
    // link.parentNode.removeChild(link);
  };

  render() {
    const { activeIndex, attachments, p_att } = this.state;
    if (p_att && p_att.length > 0) {
      let aLength = p_att.length;

      return (
        <Modal
          isOpen={this.props.showCarousel}
          modalClassName="storiesPhotosCarouselModal"
        >
          <span
            className="closeBtn cursor"
            onClick={() => this.props.closeCarousel()}
          >
            &times;
          </span>
          <ModalBody>
            {p_att.map((e, idx) => {
              let itm = uploadPreview(e);
              return (
                <div
                  className={
                    e.isHidden ? "mySlides" : "storiesCarouselCurrentItm"
                  }
                  key={idx}
                >
                  <span className="carouselItemDownload">
                    <a
                      onClick={() => this.downloadFile(itm)}
                      className="carouselItemDownload_aTag"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path>
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"></path>
                      </svg>
                      <span>Download</span>
                    </a>
                  </span>
                  {/* <div className="numbertext">{idx+1} / {aLength}</div> */}
                  {e.type &&
                  e.type.mime &&
                  e.type.mime.indexOf("video") > -1 ? (
                    <ReactPlayer
                      width="100%"
                      height="100%"
                      className="carouselVideoItm"
                      playing={true}
                      // muted={true}
                      controls={true}
                      // volume={0}
                      url={itm.preview}
                    />
                  ) : itm.isMsIcon ? (
                    <ImagePreview item={itm} key={idx} />
                  ) : (
                    <img
                      style={{ backgroundColor: itm.isMsIcon ? "white" : "" }}
                      src={itm.preview}
                    />
                  )}
                </div>
              );
            })}
            {/* &#10094;
                  &#10095; */}
            {p_att.length > 1 ? (
              <span>
                <a className="prev" onClick={() => this.plusSlides(-1)}>
                  Prev
                </a>
                <a className="next" onClick={() => this.plusSlides(1)}>
                  Next
                </a>
              </span>
            ) : null}
            <div className="carouselThumbnailContainer">
              {p_att.map((e, idx) => {
                let itm = uploadPreview(e);
                return (
                  <div
                    className={`column carouselThumbnailWidth${aLength}`}
                    key={idx}
                  >
                    {e.type &&
                    e.type.mime &&
                    e.type.mime.indexOf("video") > -1 ? (
                      <ReactPlayer
                        width="100%"
                        height="100%"
                        className={`${
                          e.isHidden ? "demo" : ""
                        } cursor columnThumbnail`}
                        onClick={() => this.currentSlide(idx)}
                        url={itm.preview}
                      />
                    ) : itm.isMsIcon ? (
                      <span onClick={() => this.currentSlide(idx)}>
                        <ImagePreview
                          className={`${
                            e.isHidden ? "demo" : ""
                          } cursor columnThumbnail`}
                          item={itm}
                          key={idx}
                        />
                      </span>
                    ) : (
                      <img
                        className={`${
                          e.isHidden ? "demo" : ""
                        } cursor columnThumbnail`}
                        style={{ backgroundColor: itm.isMsIcon ? "white" : "" }}
                        src={itm.preview}
                        onClick={() => this.currentSlide(idx)}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </ModalBody>
        </Modal>
      );
      // const slides = attachments.map((item) => {
      //   return (
      //     <CarouselItem
      //       interval={null}
      //       onExiting={this.onExiting}
      //       onExited={this.onExited}
      //       key={item.url}
      //     >
      //       <div className="storyPhotoCarouselItem">
      //           {item.type&&item.type.mime&&item.type.mime.indexOf('video')>-1?
      //               <ReactPlayer
      //               width='100%'
      //               height='100%'
      //               controls={true}
      //               url= {item.url} />
      //           :
      //             <img src={item.url} alt={item.altText} className="storyPhotoCarouselItemImg" style={{'width':'100%'}}/>
      //           }
      //       </div>
      //       {/* <CarouselCaption captionText={item.caption} captionHeader={item.caption} /> */}
      //     </CarouselItem>
      //   );
      // });

      // return (
      //   <Carousel
      //     interval={null}
      //     activeIndex={activeIndex}
      //     next={this.next}
      //     previous={this.previous}
      //   >
      //     <CarouselIndicators items={this.state.attachments} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
      //     {slides}
      //     <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
      //     <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
      //   </Carousel>
      // );
    } else {
      return <span>loading...</span>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(StoriesPhotoGrid, axios)));
